/**
 * @generated SignedSource<<dd243776297895eaa4e6418f556cc311>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BackgroundThemeEnum = "default" | "light";
import { FragmentRefs } from "relay-runtime";
export type JobsListing_Firm$data = {
  readonly backgroundTheme: BackgroundThemeEnum | null | undefined;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly jobs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"JobsListingItem_Job">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly logoUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly self: boolean | null | undefined;
  readonly slug: string | null | undefined;
  readonly video: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "JobsListing_Firm";
};
export type JobsListing_Firm$key = {
  readonly " $data"?: JobsListing_Firm$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobsListing_Firm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobsListing_Firm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundTheme",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "status": "opened"
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "JobConnection",
      "kind": "LinkedField",
      "name": "jobs",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JobEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Job",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "JobsListingItem_Job"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "jobs(filters:{\"status\":\"opened\"},first:20)"
    }
  ],
  "type": "Firm",
  "abstractKey": null
};
})();

(node as any).hash = "b310066bec9dece8af340b8b213d6838";

export default node;
